export default "__VITE_ASSET__CMEXlYIr__"